module.exports = __webpack_public_path__ + "static/media/arrow-right-circle-disabled.1ab05ba7.png";